import { faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import { Button, Form } from "react-bootstrap";
import "./Personnel_Details_Form.css";
import { Link } from "react-router-dom";
import Select from "react-select";
import Success_Toster from "../../../../../../../common/common_modal/success_toster/Success_Toster";

function Personnel_Details_Form({handleClose}) {
  const [success, setSuccess] = useState(false);

  // ⏱ auto hide success toaster after 3 sec
  useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(false);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success]);
  const designationOptions = [
    { value: "dcm_geology", label: "DCM Geology" },
    { value: "manager", label: "Manager" },
    { value: "engineer", label: "Engineer" },
  ];

  const experienceOptions = [
    { value: "6", label: "6 Months" },
    { value: "12", label: "12 Months" },
    { value: "24", label: "24 Months" },
  ];

  const qualificationOptions = [
    { value: "btech", label: "B.Tech" },
    { value: "mtech", label: "M.Tech" },
    { value: "phd", label: "PhD" },
  ];

  const specializationOptions = [
    { value: "mining", label: "Mining" },
    { value: "geology", label: "Geology" },
  ];

  const trainingOptions = [
    { value: "safety", label: "Safety Training" },
    { value: "technical", label: "Technical Training" },
  ];

  const trainingTypeOptions = [
    { value: "internal", label: "Internal" },
    { value: "external", label: "External" },
  ];

  const durationOptions = [
    { value: "1_week", label: "1 Week" },
    { value: "1_month", label: "1 Month" },
  ];

  const fileInputRef = useRef(null);

  const openFileManager = () => {
    fileInputRef.current.click();
  };

  const fileRef = useRef(null);
  const [fileName, setFileName] = useState("");

  const handleIconClick = () => {
    fileRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name);
    }
  };
  return (
    <>
      {/* ================= PERSONAL DETAILS ================= */}
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="row">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Name</Form.Label>
                <Form.Control placeholder="Enter Name" />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Designation</Form.Label>
                <Select
                  options={designationOptions}
                  placeholder="eg. Dcm geology"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Experience</Form.Label>
                <Select
                  options={experienceOptions}
                  placeholder="Experience In Months"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Qualification</Form.Label>
                <Select
                  options={qualificationOptions}
                  placeholder="Select Qualification"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Specialization</Form.Label>
                <Select
                  options={specializationOptions}
                  placeholder="Select Specialization"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach File (Degree)</Form.Label>

                <div className="absolute_fields">
                  {/* Display selected file name */}
                  <Form.Control
                    placeholder="Upload File"
                    value={fileName}
                    readOnly
                  />

                  {/* Upload Icon */}
                  <div className="upload_icon_holder" onClick={handleIconClick}>
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>

                  {/* Hidden File Input */}
                  <input
                    type="file"
                    ref={fileRef}
                    style={{ display: "none" }}
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileChange}
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Relevant Training</Form.Label>
                <Select
                  options={trainingOptions}
                  placeholder="Select Relevant Training"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group file_field">
                <Form.Label>Attach Training Certificate</Form.Label>

                <div className="absolute_fields">
                  {/* Visible input (optional – can be readonly) */}
                  <Form.Control placeholder="Upload Certificate" readOnly />

                  {/* Upload Icon */}
                  <div className="upload_icon_holder" onClick={openFileManager}>
                    <FontAwesomeIcon icon={faUpload} className="upload_icon" />
                  </div>

                  {/* Hidden file input */}
                  <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    accept=".pdf,.jpg,.jpeg,.png"
                  />
                </div>
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Mobile No</Form.Label>
                <Form.Control placeholder="Enter Mobile No" />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Email</Form.Label>
                <Form.Control placeholder="Enter Email" />
              </Form.Group>
            </div>
          </div>

          <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>

      {/* ================= TRAINING REQUEST ================= */}
      <section className="Legal_Entity_Form">
        <div className="white_container customer_section">
          <div className="note_text_holder">
            <p className="red_text">
              If you require training, please Raise a Training Request through
              the system.
            </p>
          </div>

          <div className="row">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Training Fields</Form.Label>
                <Select
                  options={trainingOptions}
                  placeholder="Select Training Fields"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Type Of Training</Form.Label>
                <Select
                  options={trainingTypeOptions}
                  placeholder="Select Type Of Training"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Duration Of Training</Form.Label>
                <Select
                  options={durationOptions}
                  placeholder="Select Duration Of Training"
                  classNamePrefix="react_select"
                />
              </Form.Group>
            </div>

            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Status Of Training:</Form.Label>
              </Form.Group>
            </div>

            <div className="col-md-12">
              <div className="note_text_holder">
                <p>
                  For detailed information about our training programs, feel
                  free to visit us:
                  <Link
                    to="http://nlcjsf.nlcindia.com:8080/LDC/faces/login.xhtml"
                    target="_blank"
                    rel="noreferrer"
                    className="ms-1 green_text"
                  >
                    http://nlcjsf.nlcindia.com:8080/LDC/faces/login.xhtml
                  </Link>
                </p>
              </div>
            </div>
          </div>

           <div className="permission_btn_holder">
            {success ? (
              <Success_Toster successText="Save Audit Successfully!" />
            ) : (
              <>
                <Button type="button" className="permission_btn No_btn">
                  Cancel
                </Button>

                <Button
                  type="button"
                  className="permission_btn Yes_btn"
                  onClick={() => setSuccess(true)}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default Personnel_Details_Form;
